export interface Filter {
  key: string;
  operation: (object: any, fieldValue: string) => boolean;
}

export enum EmpItem {
  EMP_DATA = 'EMP_DATA',
  EMP_CONTRACT = 'EMP_CONTRACT',
  EMP_VARIABLE = 'EMP_VARIABLE',
  EMP_ABSENCE = 'EMP_ABSENCE',
  EMPLOYEE = 'EMPLOYEE',
  PEOPLE_TREE_NODE = 'PEOPLE_TREE_NODE',
  REP_ENTITY = 'REP_ENTITY',
  REP_DATA = 'REP_DATA'
}
